module.exports = __webpack_public_path__ + "static/media/jungwoo-5.jpeg";